import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { LocalizationService } from "../Services/localization-service";
import { environment } from "../../environments/environment";

@Injectable({ providedIn: 'root' })
export class LanguageGuard implements CanActivate {
  constructor(
    private localizationService: LocalizationService,
    private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const rawLang = route.paramMap.get('lang') ?? environment.defaultLang;
    const lang = this.normalizeLang(rawLang);

    // Case-insensitive check to tolerate different URL casing (e.g. fa-ir vs fa-IR)
    const supportedLower = environment.supportedLangs.map(l => l.toLowerCase());
    if (!supportedLower.includes(lang.toLowerCase())) {
      await this.router.navigate(['/', environment.defaultLang]);
      return false;
    }

    await this.localizationService.setLanguage(environment.supportedLangs.find(l => l.toLowerCase() === lang.toLowerCase())!);
    return true;
  }

  /**
   * Normalizes a language tag so region part becomes uppercase (fa-ir -> fa-IR)
   * without altering already correct tags.
   */
  private normalizeLang(code: string): string {
    const parts = code.split('-');
    if (parts.length === 2) {
      return `${parts[0]}-${parts[1].toUpperCase()}`;
    }
    return code;
  }
}
